import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {AudioRecordingService} from '../../services/audio-recording.service';
import { AudioRecordingFromClient, AudioRecordingModel, AudioRecordingToClient } from '../../model/AudioRecordingModel';
import { Subscription } from 'rxjs';
import { WsAbstraction, WsService } from '../../services/ws.service';
import { FormsModule } from '@angular/forms';
import {DatePipe} from '@angular/common';



@Component({
    selector: 'app-audio-recording',
    templateUrl: './audio-recording.component.html',
    styleUrls: ['./audio-recording.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, DatePipe]
})
export class AudioRecordingComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription = new Subscription();
  private wsAbstraction: WsAbstraction<AudioRecordingFromClient, AudioRecordingToClient>;

  recordings: AudioRecordingModel[];

  stopped = true;

  filtered = true;
  firstLast: 'first'|'last' = 'last';
  nr = 1000;
  unreadOnly = true;

  constructor(
    private audioRecordingService: AudioRecordingService,
    private wsService: WsService,
  ) { }

  ngOnInit(): void {
    this.filter();
    this.wsAbstraction = this.wsService.setUpWs<AudioRecordingFromClient, AudioRecordingToClient>('/wsocket/audioRecording');
    this.subscriptions.add(
      this.wsAbstraction.read().subscribe((res: AudioRecordingToClient) => {
        if (this.firstLast === 'last') {
          this.recordings.push(res.recording);
        }
      }));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  play(index: number, continueAfterwards: boolean) {
    const recording: AudioRecordingModel = this.recordings[index];
    recording.playing = true;
    this.stopped = false;
    this.audioRecordingService.getSpecificRecording(recording.id).subscribe(res => {
      if (res.byteLength === 0) {
        this.afterListen(recording, continueAfterwards, index);
        return;
      }
      console.log(res);

      const blb: Blob = new Blob([res], {type: 'audio/mp3'});
      const url = window.URL.createObjectURL(blb);
      const audio = document.createElement('audio');
      document.body.appendChild(audio);
      audio.src = url;
      audio.onended = () => {
        console.log('ended');
        document.body.removeChild(audio);
        this.afterListen(recording, continueAfterwards, index);
      };
      audio.play().then(onfulfilled => {
        console.log('fulfilled', onfulfilled);
      }).catch(reason => {
        console.warn('reason', reason);
      });

    });
  }

  private afterListen(recording: AudioRecordingModel, continueAfterwards: boolean, index: number) {
    recording.playing = false;
    this.setListened(recording);
    if (continueAfterwards && !this.stopped && this.recordings.length > index + 1) {
      this.play(index + 1, true);
    } else {
      this.stopped = true;
    }
  }

  setListened(recording: AudioRecordingModel) {
    this.audioRecordingService.setPlayed(recording.id).subscribe({
      next: res => {
        recording.playedAt = res.playedAt;
      },
      error: error => {
        console.warn(error);
      }
    });
    this.wsAbstraction.sendMessage({msg: 'listened to ' + recording.id});
  }

  filter() {
    if (!this.filtered) {
      this.audioRecordingService.getAllRecordingEntries().subscribe(res => {
        this.recordings = res;
      });
    } else {
      this.audioRecordingService.getFilteredRecordingEntries(this.firstLast, this.nr, this.unreadOnly).subscribe(res => {
        this.recordings = res;
      });
    }
  }
}
